import { PureComponent, PropsWithChildren } from "react";

export default class ExtrasFilterAdvancedFilter extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ct-extras-filter__adv-filter">{this.props.children}</div>
    );
  }
}
